export interface ITransactionCertificate {
  id: string;
  tcFileId: string;
  status: "Processing" | "Ready" | "Failed";
  uploaded: string;
  standards: string[];
  uploadedBy: {
    userId: string;
    userName: string;
    companyName: string;
    avatarUrl: string;
  };
  sharedWith: {
    companyName: string;
    sharedDate: string;
    isCurrentUserCompany?: boolean;
  };
  isSelected?: boolean;
  key?: string;
}

export interface QuickFilters {
  all: number;
  sharedWithMe: number;
  uploadedByMe: number;
}

export interface ApiResponse {
  data: ITransactionCertificate[];
  quickFilters: QuickFilters;
  meta: {
    totalCount: number;
    page: number;
    pageSize: number;
    count: number;
  };
}


export function getAllTcs(): ApiResponse {
  // Mock data structure with quickFilters
  const mockData: ITransactionCertificate[] = [
    {
      id: "1",
      tcFileId: "GOTS-Organic-Cotton-Certificate.pdf",
      status: "Ready",
      uploaded: "2024-01-15T10:30:00Z",
      standards: ["GOTS", "OCS"],
      uploadedBy: {
        userId: "user-1",
        userName: "Sarah Johnson",
        companyName: "Sustainable Textiles Ltd",
        avatarUrl: "https://i.pravatar.cc/32?img=1"
      },
      sharedWith: {
        companyName: "3 companies",
        sharedDate: "2024-01-15T10:30:00Z",
        isCurrentUserCompany: false
      },
      key: "tc-1"
    },
    {
      id: "2",
      tcFileId: "Fair-Trade-Cotton-Certification.pdf",
      status: "Processing",
      uploaded: "2024-02-10T14:20:00Z",
      standards: ["Fair Trade", "Organic","GOTS", "OCS"],
      uploadedBy: {
        userId: "user-2",
        userName: "Michael Chen",
        companyName: "Ethical Cotton Co",
        avatarUrl: "https://i.pravatar.cc/32?img=2"
      },
      sharedWith: {
        companyName: "1 company",
        sharedDate: "2024-02-10T14:20:00Z",
        isCurrentUserCompany: true
      },
      key: "tc-2"
    },
    {
      id: "3",
      tcFileId: "OEKO-TEX-Standard-100.pdf",
      status: "Failed",
      uploaded: "2023-12-05T09:15:00Z",
      standards: ["OEKO-TEX"],
      uploadedBy: {
        userId: "user-3",
        userName: "Emma Rodriguez",
        companyName: "Clean Fabric Solutions",
        avatarUrl: "https://i.pravatar.cc/32?img=3"
      },
      sharedWith: {
        companyName: "0 companies",
        sharedDate: "2023-12-05T09:15:00Z",
        isCurrentUserCompany: false
      },
      key: "tc-3"
    },
    {
      id: "4",
      tcFileId: "Cradle-to-Cradle-Certified.pdf",
      status: "Ready",
      uploaded: "2024-03-20T16:45:00Z",
      standards: ["C2C", "Recycled"],
      uploadedBy: {
        userId: "user-4",
        userName: "David Kim",
        companyName: "Circular Materials Inc",
        avatarUrl: "https://i.pravatar.cc/32?img=4"
      },
      sharedWith: {
        companyName: "2 companies",
        sharedDate: "2024-03-20T16:45:00Z",
        isCurrentUserCompany: false
      },
      key: "tc-4"
    },
    {
      id: "5",
      tcFileId: "Better-Cotton-Initiative-Certificate.pdf",
      status: "Ready",
      uploaded: "2024-04-12T11:30:00Z",
      standards: ["BCI", "Sustainable"],
      uploadedBy: {
        userId: "user-5",
        userName: "Lisa Wang",
        companyName: "Green Cotton Corp",
        avatarUrl: "https://i.pravatar.cc/32?img=5"
      },
      sharedWith: {
        companyName: "4 companies",
        sharedDate: "2024-04-12T11:30:00Z",
        isCurrentUserCompany: true
      },
      key: "tc-5"
    }
  ];

  // Calculate quick filters based on mock data
  const quickFilters = {
    all: mockData.length,
    sharedWithMe: mockData.filter(item => item.sharedWith.isCurrentUserCompany).length,
    uploadedByMe: mockData.filter(item => item.uploadedBy.userId === "user-1").length // Mock current user
  };

  return {
    data: mockData,
    quickFilters,
    meta: {
      totalCount: mockData.length,
      page: 0,
      pageSize: 20,
      count: mockData.length,
    }
  };
}